// start:ng42.barrel
import   './document-editor.component';
import   './document-list.component';
// end:ng42.barrel

